import { render, staticRenderFns } from "./TagsSearchBar.vue?vue&type=template&id=1eab81e3&"
import script from "./TagsSearchBar.vue?vue&type=script&lang=js&"
export * from "./TagsSearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports